import FormInput from './FormInput';
import PropTypes from 'prop-types';

const CALC_METHODS = [
    { id: '2', description: 'ISNA — Islamic Society of North America' },
    { id: '3', description: 'MWL — Muslim World League' },
    { id: '1', description: 'Karachi — Univ. of Islamic Sciences' },
    { id: '4', description: 'Makkah — Umm al-Qura' },
    { id: '5', description: 'Egypt — Egyptian General Authority' },
];

const HIGH_LAT_METHODS = [
    { id: '0', description: 'None' },
    { id: '1', description: 'Midnight' },
    { id: '2', description: '1/7 of Night' },
    { id: '3', description: 'Angle-Based (recommended for high latitudes)' },
];

const CALC_SOURCES = [
    { id: 'auto', description: 'Auto — database, then calculator fallback' },
    { id: 'calc', description: 'Always use calculator' },
];

const SettingPrayerCalc = ({ DeviceSetting, onSettingChange }) => {

    const setSetting = (changedSettings) => {
        const tempSettings = [{ ...DeviceSetting }];
        changedSettings.forEach(({ setting, value }) => {
            tempSettings[0][setting] = value;
        });
        onSettingChange(tempSettings);
    };

    return (
        <>
            <FormInput
                name="calc-source"
                labelText="Time source"
                inputType="select"
                value={DeviceSetting['calc-source'] ?? 'auto'}
                options={CALC_SOURCES}
                onValueChange={(e) => setSetting([{ setting: 'calc-source', value: e }])}
            />
            <FormInput
                name="calc-method"
                labelText="Calculation method"
                inputType="select"
                value={DeviceSetting['calc-method'] ?? '2'}
                options={CALC_METHODS}
                onValueChange={(e) => setSetting([{ setting: 'calc-method', value: e }])}
            />
            <FormInput
                name="high-lat-adjust"
                labelText="High latitude adjustment"
                inputType="select"
                value={DeviceSetting['high-lat-adjust'] ?? '3'}
                options={HIGH_LAT_METHODS}
                onValueChange={(e) => setSetting([{ setting: 'high-lat-adjust', value: e }])}
            />
            <FormInput
                name="asr-method"
                labelText="Hanafi Asr"
                hint="The later of the two Asr times"
                inputType="checkbox"
                value={DeviceSetting['asr-method'] === '1'}
                onValueChange={(e) => setSetting([{ setting: 'asr-method', value: e ? '1' : '0' }])}
            />
        </>
    );
};

SettingPrayerCalc.propTypes = {
    DeviceSetting: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
};

export default SettingPrayerCalc;
